// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBKppGact4lRrO6zSR-MdwN8aoECLSAafI",
//   authDomain: "bird-voice-2025.firebaseapp.com",
//   projectId: "bird-voice-2025",
//   storageBucket: "bird-voice-2025.firebasestorage.app",
//   messagingSenderId: "523269747028",
//   appId: "1:523269747028:web:161cfaecde349fcacdd8c1",
//   measurementId: "G-TT4JNKZ4R5"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, GoogleAuthProvider, signInWithPopup, sendEmailVerification, sendPasswordResetEmail } from 'firebase/auth'
import { store } from '../store/index'
import { resetAuthError, setAuthStatus } from "../store/authSlice"


export class FirebaseClient {
    constructor() {
      this.firebaseConfig = {
        apiKey: "AIzaSyBKppGact4lRrO6zSR-MdwN8aoECLSAafI",
        authDomain: "bird-voice-2025.firebaseapp.com",
        projectId: "bird-voice-2025",
        storageBucket: "bird-voice-2025.firebasestorage.app",
        messagingSenderId: "523269747028",
        appId: "1:523269747028:web:161cfaecde349fcacdd8c1",
        measurementId: "G-TT4JNKZ4R5"
      }
      this.app = initializeApp(this.firebaseConfig)
      this.analytics = getAnalytics(this.app)
      this.auth = getAuth(this.app)
    }

async isAuth() {
  const authStateChanged = await new Promise((resolve) => {
    const unsubscribe = this.auth.onAuthStateChanged((user) => {
      unsubscribe()
      resolve(user)
    })
  })

  if (authStateChanged) {
    return authStateChanged
  } else {
    return null
  }
}

    async signInWithEmailAndPassword(email, password) {
      try {
        const userCredential = await signInWithEmailAndPassword(this.auth, email, password)
        const user = userCredential.user
        return user
      } catch (error) {
        const {code, message} = error
        store.dispatch(resetAuthError({code, message}))
      }
    }
  
    async signUpWithEmailAndPassword(email, password) {
      try {
        const userCredential = await createUserWithEmailAndPassword(this.auth, email, password)
        const user = userCredential.user
        await sendEmailVerification(user)
        return user
      } catch (error) {
        const {code, message} = error
        store.dispatch(resetAuthError({code, message}))
      }
    }
    
    async signInWithGoogle() {
      try {
        const provider = new GoogleAuthProvider();
        const result = await signInWithPopup(this.auth, provider)
        const user = result.user;
        // console.log(user);
        return user;
      } catch (error) {
        if (error.code === 'auth/popup-closed-by-user' || 'auth/cancelled-popup-request') {
          return
        } else {
          throw error
        }
      }
    }

    async signOut() {
      try {
        await this.auth.signOut()
      } catch (error) {
        throw error
      }
    }

    async deleteAccount() {
      try {
        const user = this.auth.currentUser
          await user.delete()
      } catch (error) {
          const {code, message} = error
          store.dispatch(resetAuthError({code, message}))
      }
    }

    async sendPasswordReset(email) {
      try {
        await sendPasswordResetEmail(this.auth, email)
        store.dispatch(setAuthStatus(null))
      } catch (error) {
        const {code, message} = error
          store.dispatch(resetAuthError({code, message}))
        }
    }
  }

